import { useSettingsContext } from "../atlas/contexts/Settings/SettingsContextProvider";
import { FEATURES } from "../constants/features";

export const useSelfInitiatedAssessments = (): boolean => {
  const { isFeatureEnabled } = useSettingsContext();

  return isFeatureEnabled(FEATURES.SELF_ASSESSMENTS);
};
